<template>
    <div class="agent_container">
        <CustomHeader text="Agente" @closePopup="close" />
        <div class="container">
            <img :src="dataSet.bannerImage" alt="">
            <van-tabs v-model="active" sticky :ellipsis="false" @click-tab="onClickTab">
                <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="index">
                </van-tab>
            </van-tabs>

        </div>
        <InvitationView v-if="dataSet.activeTab == 0" @closePoup="close" />
        <MyDataView v-if="dataSet.activeTab == 1" />
        <CommissionView v-if="dataSet.activeTab == 2" />
        <DetailsView v-if="dataSet.activeTab == 3" />
        <FaqView v-if="dataSet.activeTab == 4" />
    </div>

</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import InvitationView from './components/invitationView.vue';
import MyDataView from './components/myDataView.vue';
import CommissionView from './components/commissionView.vue';
import DetailsView from './components/detailsView.vue';
import FaqView from './components/faqView.vue';
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity';
import { AgentData, TAB_LIST } from '@/view/agent/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const { t } = useI18n();
const show = ref(false)

const tabList = ref(TAB_LIST)
const activeTab = ref(0)
const emit = defineEmits(['onClickTab', 'close', 'update:show'])

const props = defineProps<{
    dataSet: AgentData
}>()
const active = ref(props.dataSet.activeTab)

watch(active, (val) => {
    emit('update:show', val)
})

const close = () => {
    router.go(-1)
}
const onClickTab = (value: any) => {
    emit('onClickTab', value)
}

</script>
<style scoped>
.agent_container {
    min-height: 100vh;
    padding: 100px 0;
    overflow-y: auto;
    background: #090F1F;
}

.agent_container::-webkit-scrollbar {
    display: none;
}

.scrollable-content {
    /* flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; */
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.container {
    width: 100%;
}

.container img {
    width: 100%;
}

.container>>>.van-tabs__wrap {
    background: rgba(3, 11, 32, 0.50);
    backdrop-filter: blur(8px);
    margin-top: -40px;
    height: 35px;
}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    color: rgba(255, 255, 255, 0.85);
    border-radius: 10px;
    font-size: 15px;
    margin: 0 3px;
    padding: 0 10px;
    min-width: 25%;
}

.container>>>.van-tab.van-tab--active {
    color: #ffffff;
    background-image: linear-gradient(0deg, #0167ca 0%, #38a8fa 100%);
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}
</style>